const shopifyEndpoint = 'https://'+shopDomain+'/api/2023-10/graphql.json';
const storefrontAccessToken  = "bc56e947f925c5c7afbd2775950f894c";
  
jQuery(function($){
  const targetNode = document.body;
  const config = { childList: true, subtree: true };
  const callback = function(mutationsList, observer) {
      for (let mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
              mutation.addedNodes.forEach(function(node) {
                  if ($(node).is('.gl-card') || $(node).find('.gl-card').length > 0) {
                      $i = 0;
                      $('.gl-card').each(function() {
                        var $gl_card = $(this);
                        if(!$gl_card.hasClass('hidden-product')){
                          cardProductSwatches($gl_card);
                        } else {
                          //console.log
                        }                   
                      });
                  }
              });
          }
      }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);

    $(document).on('mouseenter click', '.card-swatch-item', function(event) {
      console.log('hovered')
      var $swatch = $(this);
      var $product_card = $swatch.parent().parent();
      var $product_url = $swatch.parent().data('product-url')+'?variant='+$swatch.data('variant-id');
      $product_card.find('.card__content h3 a').attr('href',$product_url);
  
      var $img_default = $swatch.data('img-default');
      var $img_hover = $swatch.data('img-hover');
      $img_hover = ($img_hover=='')?$img_default:$img_hover
      
      if($img_default!=''){
        $product_card.find('.card__media .media img:first-child').attr('src',$img_default);
      }
      if($img_hover!=''){
        $product_card.find('.card__media .media img:last-child').attr('src',$img_hover);
      }
  
      $product_card.find('.card-swatch-item').removeClass('active');
      $swatch.addClass('active');
      
    });

    $(document).on('mouseenter click', '.search-swatch-item', function(event) {
      
      var $swatch = $(this);
      var $gl_card = $swatch.parent().parent();
      var $product_url = $swatch.parent().data('product-url')+'?variant='+$swatch.data('variant-id');
      $gl_card.find('a').attr('href',$product_url);
  
      var $img_default = $swatch.data('img-default');
      if($img_default!=''){
        $gl_card.find('.gl-card-thumbnail img:first-child').attr('src',$img_default);
      }
  
      $gl_card.find('.search-swatch-item').removeClass('active');
      $swatch.addClass('active');
      
    });
});

function cardProductSwatches($gl_card){
  var productHandle = $gl_card.data('product-handle');
  if(productHandle=='' || productHandle === undefined ) return;
    const query = `
    query getProduct($handle: String!) {
      productByHandle(handle: $handle) {
        id
        title
         metafields(identifiers: [
          { namespace: "combined_listing", key: "product_handle" },
        ]) {
          namespace
          key
          value
          type
        }
        options {
          id
          name
          values
        }
        variants(first: 10) {
          edges {
            node {
              id
              title
              image {
                url
                altText
              }
              selectedOptions {
                name
                value
              }
              availableForSale
              metafields(identifiers: [
                { namespace: "custom", key: "hide_variant" },
                { namespace: "custom", key: "call_to_buy" },
              ]) {
                namespace
                key
                value
                type
              }
            }
          }
        }
      }
    }`;

    $.ajax({
        url: shopifyEndpoint,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontAccessToken
        },
        data: JSON.stringify({
            query: query,
            variables: { handle: productHandle }
        }),
        success: function(response) {
          const product = response.data.productByHandle;
          if (product) {
            //console.log('Product:', product.title);
            var $color_swatches = '';
            var $swatches_shown = 0;
            var $do_not_inc = false;
            var cmbProductHandle = productHandle;
            product.metafields.forEach(function(metafield) {
              if(metafield!==null && metafield.key == 'product_handle' && metafield.value != '' ){
                cmbProductHandle = metafield.value;
              }
            });
            
            product.options.forEach(function(option) {
                if(option.name == '__Color' ||option.name == 'Color' || option.name == 'Colour' || option.name == '色'){
                  option.values.forEach(function(value) {
          
                        var show_swatch = true

                        if(cmbProductHandle != ''){
                          if($variant_metas && $variant_metas[cmbProductHandle]){
                            var $cmb_variant_meta = $variant_metas[cmbProductHandle];
                            for (var variantId in $cmb_variant_meta) {
                              var variant_meta = $variant_metas[cmbProductHandle][variantId];
                              if (variant_meta.option_1 == value || variant_meta.option_2 == value || variant_meta.option_3 == value){
                                if(variant_meta.available == false ){
                                  /*if(variant_meta.call_to_buy == false){
                                    var show_swatch = false
                                  }*/
                                } else {
                                  if(variant_meta.hide_variant == true){
                                    var show_swatch = false
                                  }
                                }
                              }
                              //incrementing here only for CL product
                              if(show_swatch == true){
                                $swatches_shown++;
                                $do_not_inc = true;
                              }
                            }
                          } else {
                            
                          }
                          
                        }else{
                          product.variants.edges.forEach(function(variantEdge) {
                            const variant = variantEdge.node;
                            variant.selectedOptions.forEach(function(variantOption) {
                              //console.log(product.title,variantOption.value, value,variant.availableForSale)
                              if (variantOption.value == value){
                                if(variant.availableForSale == false){
                                  /* variant.metafields.forEach(function(metafield) {
                                    if(metafield!==null && metafield.key == 'call_to_buy' && metafield.value != true ){
                                      var show_swatch = false
                                    }
                                  }); */
                                } else {
                                  variant.metafields.forEach(function(metafield) {
                                    if(metafield!==null && metafield.key == 'hide_variant' && metafield.value == true ){
                                      var show_swatch = false
                                    }
                                  });
                                }
                              }
                            });
                          });
                        }

                        if(show_swatch == true){
                          if($do_not_inc == false)
                            $swatches_shown++;
                          /* if($swatches_shown <= 3){
                            
                            var variant_id = '';
                            var variant_img = '';
                            $.each($colors_json, function(index, color) {
                              if(color.color_name_1 == value || color.color_name_2 == value || color.color_name_3 == value){
                                
                                //find current color variant id
                                if(cmbProductHandle != ''){
                                  if($variant_metas && $variant_metas[cmbProductHandle]){
                                    var $cmb_variant_meta = $variant_metas[cmbProductHandle];

                                    for (var variantId in $cmb_variant_meta) {
                                      var variant_meta = $variant_metas[cmbProductHandle][variantId];
                                      if (variant_meta.option_1 == value || variant_meta.option_2 == value || variant_meta.option_3 == value){
                                        variant_id = variantId;
                                        if(variant_meta.image != null){
                                          variant_img = variant_meta.image
                                          console.log('var img found',variant_meta,cmbProductHandle)
                                        } else {
                                          console.log('var img not found')
                                        }
                                      }
                                    }
                                    
                                    
                                  } else {
                                        
                                        product.variants.edges.forEach(function(variantEdge) {
                                          const variant = variantEdge.node;
                                          variant.selectedOptions.forEach(function(variantOption) {
                                            //console.log('VOV',variant_id,variantOption.value,value)
                                            if (variantOption.value == value){
                                              variant_id = getVariantNumericId(variant.id);
                                              if(variant.image != null){
                                                variant_img = variant.image.url
                                              }
                                            }
                                            
                                          });                        
                                        });
                                  }
                                }
    
                              $color_swatches += '<label data-variant-id="'+ variant_id +'" data-img-default="'+ variant_img +'" data-img-hover="'+ variant_img +'" class="search-swatch-item">';
                              if(color.color_img != '' && color.color_img != 'null') {
                                $color_swatches += '<span class="swatch-item swatch-image"><img src="'+ color.color_img +'" alt="'+value+'" title="'+value+'" width="50" height="50" /></span>';
                                return;
                              }else if(color.color_code != ''){
                                $color_swatches += '<span class="swatch-item swatch-color"><span title="'+value+'" style="background:'+ color.color_code +'!important;width:32px;height:32px;">&nbsp;</span></span></label>';
                                return;
                              } else{
                                $color_swatches += '<span class="swatch-item swatch-color"><span title="'+value+'" style="background:'+ value +'!important;width:32px;height:32px;">&nbsp;</span></span></label>';
                                return;
                              } 
  
                                
                            }
                          });
                        } */

                        
                      }
                  });

                  if($swatches_shown > 3 ){
                    $more_swatches = $swatches_shown - 3;
                    $color_swatches += '<span class="more-swatches">+'+ $more_swatches +'</span>'
                  }
                  
                }
            });


            if(shop_country == 'US'){
              var text_colors = "Colors";
              var text_color = "Color";
            } else if(shop_country == 'JP'){
              var text_colors = "色";
              var text_color = "色";
            } else {
              var text_colors = "Colours";
              var text_color = "Colour";
            }
            
            if($swatches_shown > 0){
              if($swatches_shown == 2){
                $gl_card.find('.gl-card-pricing').after('<div class="product-card-swatches" data-product-url="/products/'+ cmbProductHandle +'">+1 '+ text_colors +' </div>');
              } else if($swatches_shown > 2){
                $gl_card.find('.gl-card-pricing').after('<div class="product-card-swatches" data-product-url="/products/'+ cmbProductHandle +'">+'+ ($swatches_shown - 1) +' '+ text_colors +' </div>');
              }
            } else {
              $gl_card.find('.gl-card-pricing').after('<div class="product-card-swatches visibility-hidden"><label class="search-swatch-item"><span class="swatch-item swatch-color"><span title="blank" style="background:#fff!important;width:32px;height:32px;">&nbsp;</span></span></label></div>');
            }
            $gl_card.find('.gl-card-thumbnail img').removeAttr('srcset').removeAttr('data-srcset');
            
          } else {
            $gl_card.find('.gl-card-pricing').after('<div class="product-card-swatches visibility-hidden"><label class="search-swatch-item"><span class="swatch-item swatch-color"><span title="blank" style="background:#fff!important;width:32px;height:32px;">&nbsp;</span></span></label></div>');
            console.error('Product not found or invalid handle: '+productHandle);
          }
        },
        error: function(xhr, status, error) {
            console.error('Error fetching product details:', error);
        }
    });
  
}

function getVariantNumericId(gid) {
  var numericId = gid.split('/').pop();
  return numericId;
}
  
